import { EventListPresenterRequest } from "../../contracts";

export type EventsRequest = {
    request: EventListPresenterRequest,
    type: EventsRequestType
}

export enum EventsRequestType {
    ByTopLeagues = "ByTopLeagues",
    ByEventIds = "ByEventIds",
    ByLeagueIds = "ByLeagueIds"
}